/* eslint-disable max-lines-per-function */
import {Util} from 'yougile-util'
import {baseProPriceRub, calculatePrice, calculatePricePro} from 'yougile-model'

const addCoffee = (): void => {
  let current = 4
  const pics = document.querySelectorAll<HTMLElement>('.s-price__coffee')
  const len = pics.length
  for (let i = 0; i < len; i++) {
    pics[i].addEventListener('click', () => {
      current = (current + 1) % pics.length
      pics[i].classList.remove('active')
      pics[current].classList.add('active')
    })
  }
}

const addPriceTable = (): void => {
  const btns = document.querySelectorAll('.s-price__table-head-item')
  const items = document.querySelectorAll('.s-price__table-item')
  for (let i = 0; i < btns.length; i++) {
    btns[i].addEventListener('click', () => {
      for (let j = 0; j < btns.length; j++) {
        items[j].classList.remove('active')
        btns[j].classList.add('clickable')
      }
      items[i].classList.add('active')
      btns[i].classList.remove('clickable')
    })
  }
}

const writePriceToElement = (cell: HTMLElement, isPro: boolean): void => {
  const months = +cell.dataset.m
  const users = +cell.dataset.u
  const isPerMonth = cell.dataset.perMonth !== undefined
  const fn = isPro ? calculatePricePro : calculatePrice
  const price = Math.round(fn(months, users) * (isPerMonth ? 1 / months : 1))
  cell.textContent = Util.amountToStr(price)
}

const calcPricesTable = (): void => {
  const cloudCells = document.body.querySelectorAll<HTMLElement>(
    '.price-cloud [data-m][data-u]'
  )
  for (const cell of Util.iter(cloudCells)) {
    writePriceToElement(cell, false)
  }
  const boxCells = document.body.querySelectorAll<HTMLElement>(
    '.price-box [data-m][data-u]'
  )
  for (const cell of Util.iter(boxCells)) {
    writePriceToElement(cell, true)
  }
}

export const addPrices = (): void => {
  calcPricesTable()
  addCoffee()
  addPriceTable()
  let months = 12
  let users = 10
  const resultElems = document.querySelectorAll('.s-price__res')
  const overlay = document.querySelector<HTMLElement>('.s-price__drag-overlay')
  if (!overlay) {
    return
  }
  const cloudRes = resultElems[0]
  const boxRes = resultElems[1]

  const boxWrongPriceContainer = document.querySelector<HTMLElement>(
    '.s-prices-wrong-container'
  )
  const boxWrongPrice = document.querySelector<HTMLElement>(
    '.s-prices__res_wrong'
  )

  const inputSlider = document.querySelector<HTMLDivElement>('.inputslider')
  const selectedNum =
    document.querySelector<HTMLInputElement>('.s-price__calc-num')
  const colsCnt = document.querySelector<HTMLElement>('.s-price__calc-cols')
  const call = document.querySelector<HTMLElement>('.s-price__calc-call')

  const monthBtns = document.querySelectorAll('.s-price__calc-dur-item')
  const monthList = [1, 3, 6, 12, 24]
  // const discountBox = [
  //   'без скидки',
  //   'без скидки',
  //   '<b>скидка 15%</b><br> при оплате за 6 мес.',
  //   '<b>скидка 40%</b><br> при оплате за год',
  //   '<b>скидка 50%</b><br> при оплате за 2 года'
  // ]
  // const discountCloud = [
  //   '',
  //   '',
  //   ' и <b>скидка 15%</b> при оплате за 6 мес.',
  //   ' и <b>скидка 40%</b> при оплате за год',
  //   ' и <b>скидка 50%</b> при оплате за 2 года'
  // ]
  const discountBox = [
    '<p class="lead-lg lead-md lead-sm lead-xs mb-0">без скидки</p>',
    '<p class="lead-lg lead-md lead-sm lead-xs mb-0">без скидки</p>',
    '<span class="badge bg-danger rounded-pill lead-lg lead-md lead-xs fw-normal ps-0d75 pe-0d75 pt-0d25 pb-sm-0 pb-0d125">скидка 15% при оплате за 6 мес.</span>',
    '<span class="badge bg-danger rounded-pill lead-lg lead-md lead-xs fw-normal ps-0d75 pe-0d75 pt-0d25 pb-sm-0 pb-0d125">скидка 40% при оплате за год</span>',
    '<span class="badge bg-danger rounded-pill lead-lg lead-md lead-xs fw-normal ps-0d75 pe-0d75 pt-0d25 pb-sm-0 pb-0d125">скидка 50% при оплате за 2 года</span>'
  ]
  const discountCloud = [
    '',
    '',
    ' и скидка 15% при оплате за 6 мес.',
    ' и скидка 40% при оплате за год',
    ' и скидка 50% при оплате за 2 года'
  ]
  const freeCloud = 'Первые 10 пользователей бесплатно'
  const freeCloud2 = 'Первые 10 пользователей бесплатно'
  const discCloudEl = document.querySelector('.s-price__calc-disc-cloud')
  const discBoxEl = document.querySelector('.s-price__calc-disc-box')
  const per = document.querySelectorAll('.s-price__calc-per')

  const up = (): void => {
    const cloudUsers = Math.max(0, users - 10)
    const cloudSum = calculatePrice(months, cloudUsers)
    cloudRes.textContent = Util.amountToStr(cloudSum)
    boxRes.textContent = Util.amountToStr(calculatePricePro(months, users))

    months >= 6
      ? (boxWrongPriceContainer.style.display = 'block')
      : (boxWrongPriceContainer.style.display = 'none')

    boxWrongPrice.textContent =
      Util.amountToStr(baseProPriceRub * users * months) + ' руб.'

    for (const p of Util.iter(per)) {
      p.textContent = (
        {
          1: 'месяц',
          3: '3 мес',
          6: '6 мес',
          12: 'год',
          24: '2 года'
        } as {[m: number]: string}
      )[months]
    }

    discBoxEl.innerHTML = discountBox[monthList.indexOf(months)]
    discCloudEl.innerHTML =
      cloudSum > 0
        ? freeCloud2 + discountCloud[monthList.indexOf(months)]
        : freeCloud
  }
  up()

  for (let i = 0; i < monthBtns.length; i++) {
    monthBtns[i].addEventListener('click', () => {
      document
        .querySelector('.s-price__calc-dur-item.active')
        .classList.remove('active')
      monthBtns[i].classList.add('active')

      if (i >= monthList.length) {
        inputSlider.classList.add('disabled')
        selectedNum.disabled = true
        colsCnt.style.display = 'none'
        // call.style.display = 'inline-block'
        call.style.display = 'flex'
      } else {
        inputSlider.classList.remove('disabled')
        selectedNum.disabled = false
        colsCnt.style.display = 'flex'
        call.style.display = 'none'

        months = monthList[i]
        up()
      }
    })
  }

  const slidePoints = [
    ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    ...[11, 12, 15, 17, 19, 20, 22, 25, 27, 30, 35, 40, 45, 50, 60, 70, 80, 90],
    ...[100, 110, 120, 130, 150, 170, 200, 250, 350, 400, 450, 500],
    ...[600, 700, 800, 900, 1000]
  ]
  const pointsCount = slidePoints.length

  const slide = document.querySelector('.s-price__calc-slide')
  const rect = slide.getBoundingClientRect()
  const slideParam = {
    x: rect.x,
    width: rect.width
  }
  const slideChosen = document.querySelector<HTMLElement>(
    '.s-price__calc-slide-chosen'
  )
  const slideBtn = document.querySelector<HTMLDivElement>(
    '.s-price__calc-slide-chosen-circle'
  )
  const numInput =
    document.querySelector<HTMLInputElement>('.s-price__calc-num')
  const updateFromInput = (): void => {
    const val = +numInput.value
    if (val > 0 && val <= 1000) {
      users = val
      let maxLessIx = 0
      for (let i = 0; i < pointsCount; i++) {
        if (slidePoints[i] < val) {
          maxLessIx = i
        }
      }
      const maxLess = slidePoints[maxLessIx]
      const next = slidePoints[maxLessIx + 1]
      const percent =
        (100 * (maxLessIx + (val - maxLess) / (next - maxLess))) / pointsCount

      slideChosen.style.width = percent + '%'
      up()
    }
  }
  numInput?.addEventListener('keyup', updateFromInput)
  numInput?.addEventListener('change', updateFromInput)
  const mouseState = {startX: 0, x: 0}
  const slideCnt = document.querySelector('.s-price__calc-slide-cnt')
  const setPercent = (percent: number): void => {
    const ix = Math.ceil(((pointsCount - 1) * percent) / 100)
    const val = +(numInput?.value ?? 0)
    users = slidePoints[ix]
    if (val !== users) {
      requestAnimationFrame(() => {
        const res = Math.round((100 * ix) / pointsCount)
        slideChosen.style.width = res + '%'
        numInput.value = users + ''
        up()
      })
    }
  }
  slideCnt?.addEventListener('click', (e: MouseEvent) => {
    const x = e.clientX
    const percent = (100 * (x - slideParam.x)) / slideParam.width
    if (percent >= 0 && percent <= 100) {
      setPercent(percent)
    }
  })
  const mouseMove = (e: MouseEvent): void => {
    mouseState.x = e.clientX
    const percent = Math.max(
      0,
      Math.min(100, (100 * (mouseState.x - slideParam.x)) / slideParam.width)
    )
    setPercent(percent)
  }
  const mouseUp = (): void => {
    overlay.style.display = 'none'
    document.removeEventListener('mouseup', mouseUp)
    document.removeEventListener('mousemove', mouseMove)
  }
  slideBtn?.addEventListener('mousedown', (e: MouseEvent) => {
    mouseState.startX = e.clientX
    mouseState.x = e.clientX
    overlay.style.display = 'block'
    document.addEventListener('mouseup', mouseUp)
    document.addEventListener('mousemove', mouseMove)
  })
}
